export default function () {
  return [{
    title: 'Operacional',
    items: [{
      title: 'Tempo real',
      to: '/analytics',
      htmlBefore: '<i class="fas fa-fire"></i>',
      htmlAfter: '',
    }, {
      title: 'Transações',
      to: '/ecommerce',
      htmlBefore: '<i class="fas fa-random"></i>',
      htmlAfter: '',
    }, {
      title: 'Clientes',
      to: '/blog-overview',
      htmlBefore: '<i class="fas fa-users"></i>',
      htmlAfter: '',
    }],
  },
  {
    title: 'Financeiro',
    items: [{
      title: 'Conta Corrente',
      htmlBefore: '<i class="fas fa-money-check-alt"></i>',
    },
    {
      title: 'Dados de Recebimento',
      htmlBefore: '<i class="fas fa-wallet"></i>',
      to: {
        name: 'user-profile-lite',
      },
    }, {
      title: 'Antecipação de Saldo',
      htmlBefore: '<i class="fas fa-history"></i>',
      to: {
        name: 'edit-user-profile',
      },
    }, {
      title: 'Transferencia Bancária',
      htmlBefore: '<i class="fas fa-exchange-alt"></i>',
      to: {
        name: 'login',
      },
    }],
  }, {
    title: 'Pagamentos',
    items: [{
      title: 'Realizar Cobrança',
      htmlBefore: '<i class="fas fa-shopping-cart"></i>',
      to: {
        name: 'components-overview',
      },
    }, {
      title: 'Gerenciar Cobranças',
      htmlBefore: '<i class="fas fa-tag"></i>',
      to: {
        name: 'tables',
      },
    },
    ],
  }, {
    title: 'Marketplace',
    items: [{
      title: 'Gerenciar Contas',
      htmlBefore: '<i class="fas fa-project-diagram"></i>',
      to: {
        name: 'header-navigation',
      },
    }, {
      title: 'Incluir Subconta',
      htmlBefore: '<i class="fas fa-user-friends"></i>',
      to: {
        name: 'icon-sidebar-nav',
      },
    }],
  },
  ];
}



// WEBPACK FOOTER //
// ./src/data/sidebar-nav-items.js